import AudioManager from "../Shared/AudioManager";
import Utils from "../Shared/Utils";
import CommonToggleContainer from "../Common/CommonToggleContainer";
import ToggleItem from "../Common/ToggleItem";
import NetworkLogic from "../Shared/NetworkLogic";
import {Global} from "../Shared/Global";
const i18n = require('LanguageData');

const { ccclass, property } = cc._decorator;

@ccclass
export default class ChangeMusicLayer extends cc.Component {
    @property(cc.Label)
    lbMusicName: cc.Label = null

    @property(cc.Node)
    nodeMusicPlay: cc.Node = null

    @property(cc.Node)
    nodeMusicPause: cc.Node = null

    @property(cc.Node)
    nodeTemplateMusic: cc.Node = null

    @property(CommonToggleContainer)
    toggleContainerMusic: CommonToggleContainer = null

    onLoad() {
        this.lbMusicName.string = ""
        this.nodeTemplateMusic.parent = null
        let isMusicPaused = cc.sys.localStorage.getItem(Global.localStorageId.pauseMusic);
        if (isMusicPaused === "true") {
            this.nodeMusicPause.active = false
            this.nodeMusicPlay.active = true
        } else {
            this.nodeMusicPause.active = true
            this.nodeMusicPlay.active = false
        }
    }

    async start() {
        //this.createMusicItem({name: "为了胜利", url: "bg.mp3"})
        let data = await AudioManager.getMuiscList();

        if (Array.isArray(data)){
            for (let i = 0;i < data.length;i++){
                let cfg = data[i];
                this.createMusicItem(cfg,i)
            }
        }

    }

    onDestroy() {
        this.nodeTemplateMusic.destroy()
    }

    onBtnClick(eventTouch, userData) {
        if (userData === "play") {
            cc.sys.localStorage.setItem(Global.localStorageId.pauseMusic,"false");
            AudioManager.resumMusic()

            this.nodeMusicPause.active = true
            this.nodeMusicPlay.active = false
        } else if (userData === "pause") {
            AudioManager.pauseMusic()
            cc.sys.localStorage.setItem(Global.localStorageId.pauseMusic,"true");
            this.nodeMusicPause.active = false
            this.nodeMusicPlay.active = true
        } else if (userData === "left") {
            for (let i = 0; i < this.toggleContainerMusic.node.children.length; i++) {
                const toggle = this.toggleContainerMusic.node.children[i].getComponent(ToggleItem)
                if (toggle && toggle === this.toggleContainerMusic.checkedToggle) {
                    let j = i === 0 ? this.toggleContainerMusic.node.children.length - 1 : i - 1
                    let newToggle = this.toggleContainerMusic.node.children[j].getComponent(ToggleItem)
                    newToggle && this.toggleContainerMusic.selectToggle(newToggle)
                    break
                }
            }
        } else if (userData === "right") {
            for (let i = 0; i < this.toggleContainerMusic.node.children.length; i++) {
                const toggle = this.toggleContainerMusic.node.children[i].getComponent(ToggleItem)
                if (toggle && toggle === this.toggleContainerMusic.checkedToggle) {
                    let j = i === this.toggleContainerMusic.node.children.length - 1 ? 0 : i + 1
                    let newToggle = this.toggleContainerMusic.node.children[j].getComponent(ToggleItem)
                    newToggle && this.toggleContainerMusic.selectToggle(newToggle)
                    break
                }
            }
        }
    }

    onSelectToggleMusic(toggle: ToggleItem) {
        let musicCfg = toggle.node["musicCfg"]

        if (musicCfg) {
            this.lbMusicName.string = musicCfg.name

            if (cc.sys.localStorage.getItem(Global.localStorageId.MusicName) === musicCfg.url.substring(musicCfg.url.lastIndexOf("/") + 1)) {
                return
            }

            let musicFileName = musicCfg.url.substring(musicCfg.url.lastIndexOf("/") + 1, musicCfg.url.lastIndexOf("."))
            let extName = musicCfg.url.substring(musicCfg.url.lastIndexOf("."))
            cc.log("===musicCfg.url:",musicCfg.url);
            cc.log("===musicFileName:",musicFileName);
            cc.log("===extName:",extName);

                let folderPath = jsb.fileUtils.getWritablePath() + "SoundCache/"
                let filePath = folderPath + musicFileName + extName

                if (jsb.fileUtils.isFileExist(filePath)) {
                AudioManager.loadMusic(filePath,musicFileName + extName)
                            this.recordMusic(musicFileName + extName)

                // cc.loader.load(filePath, function (err, clip) {
                //     if (!err) {
                //         AudioManager.startPlayBgMusic(clip)
                //         this.recordMusic(musicFileName + extName)
                //     }
                // }.bind(this))
                } else {
                    let bar = toggle.node.getChildByName("progressBar").getComponent(cc.ProgressBar)

                    // 已经在下载的话，就跳过
                    if (bar.node.active) {
                        return
                    }

                    !jsb.fileUtils.isDirectoryExist(folderPath) && jsb.fileUtils.createDirectory(folderPath)
                    bar.node.active = true
                    bar.progress = 0

                    Utils.saveUrlFile(musicCfg.url, filePath, function (fullPath) {
                        if (!bar || !bar.isValid) return
                        bar.node.active = false

                    AudioManager.loadMusic(fullPath,musicFileName + extName)
                                this.recordMusic(musicFileName + extName)

                    // cc.loader.load(fullPath, function (err, clip) {
                    //     if (!err) {
                    //         AudioManager.startPlayBgMusic(clip)
                    //         this.recordMusic(musicFileName + extName)
                    //     }
                    // }.bind(this))
                    }.bind(this), function (progress) {
                        bar.progress = progress
                    }.bind(this))
                }

            // AudioManager.startPlayBgMusic(musicFileName, function (err) {
            //     if (!err) {
            //         this.recordMusic(musicFileName + extName)
            //         return
            //     }
            //
            //     let folderPath = jsb.fileUtils.getWritablePath() + "SoundCache/"
            //     let filePath = folderPath + musicFileName + extName
            //
            //     if (jsb.fileUtils.isFileExist(filePath)) {
            //         cc.loader.load(filePath, function (err, clip) {
            //             if (!err) {
            //                 AudioManager.startPlayBgMusic(clip)
            //                 this.recordMusic(musicFileName + extName)
            //             }
            //         }.bind(this))
            //     }else {
            //         let bar = toggle.node.getChildByName("progressBar").getComponent(cc.ProgressBar)
            //
            //         // 已经在下载的话，就跳过
            //         if (bar.node.active) {
            //             return
            //         }
            //
            //         !jsb.fileUtils.isDirectoryExist(folderPath) && jsb.fileUtils.createDirectory(folderPath)
            //         bar.node.active = true
            //         bar.progress = 0
            //
            //         Utils.saveUrlFile(musicCfg.url, filePath, function (fullPath) {
            //             if (!bar || !bar.isValid) return
            //             bar.node.active = false
            //             cc.loader.load(fullPath, function (err, clip) {
            //                 if (!err) {
            //                     AudioManager.startPlayBgMusic(clip)
            //                     this.recordMusic(musicFileName + extName)
            //                 }
            //             }.bind(this))
            //         }.bind(this), function (progress) {
            //             bar.progress = progress
            //         }.bind(this))
            //     }
            // }.bind(this))
        }
    }

    private recordMusic(name: string) {
        this.nodeMusicPlay.active = false
        this.nodeMusicPause.active = true
        cc.sys.localStorage.setItem(Global.localStorageId.MusicName, name)
    }

    private createMusicItem (musicCfg,i) {
        let musicName = cc.sys.localStorage.getItem(Global.localStorageId.MusicName) || ""
        let toggle = cc.instantiate(this.nodeTemplateMusic).getComponent(ToggleItem)
        toggle.node.getChildByName("progressBar").active = false
        toggle.node.getChildByName("name").getComponent(cc.Label).string = musicCfg.name
        toggle.node["musicCfg"] = musicCfg
        this.toggleContainerMusic.addToggle(toggle)
        let urlName = musicCfg.url.substring(musicCfg.url.lastIndexOf("/") + 1);
        if  (!musicName){
            if (i == 0){
                this.toggleContainerMusic.selectToggle(toggle)
            }
        }
        else if (musicCfg.url.substring(musicCfg.url.lastIndexOf("/") + 1) === musicName) {
            this.toggleContainerMusic.selectToggle(toggle)
        }
    }
}
